import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Button from "../../../../../components/Buttons";
import Input from "../../../../../components/Input";
import UploadFile from "../../../../../components/UplodeFile/UploadFile";
import { Helmet } from 'react-helmet';
import shortid from 'shortid';
import _ from 'lodash';
import {addNewBlog, fetchSingleBlog, updateBlog} from "../../../adminAction";
import { useParams, useNavigate } from "react-router-dom";
import { DatePicker } from "antd";
import dayjs from 'dayjs';
import styled from "styled-components";
import moment from "moment";
import { getFormattedTime } from "../../../../../util/timeUtility";
import ErrorMessage from "../../../../../components/ErrorMessage";
import Box from "../../../../../components/Box";
import { useTranslation } from "react-i18next";
import { background } from "styled-system";

const MIN_LENGTH = 50
const MAX_LENGTH = 500 
const DatePickerBox = styled.div`
  .ant-picker {
    width: 100%;
    height: 54px;
    border: 1px solid #EFF0F7;
    box-shadow: 0px 2px 6px #13124212;
    border-radius: 8px;
  }
  .ant-picker-focused {
    border: 1px solid #EFF0F7;
    box-shadow: 0px 2px 6px #13124212;
    border-radius: 8px;
  }

  .ant-picker .ant-picker-input > input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #1A1A1A
  }
`;

function PublishBlog({selectedSegment}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {blog_id} = useParams();
    const {blog_url} = useParams();
    const {t} = useTranslation();

    const editBlog = useSelector((state) => state.adminReducer.edit_blog);
    const activeEntity = useSelector((state) => state.adminReducer.activeEntity);
    const [errorData, setErrors] = useState({});

    const [blogData, setBlogData] = useState({
        heading: "",
        text: "",
        preview_image: "",
        preview_image_alt: "",
        author_image: "",
        author_image_alt: "",
        author_name: "",
        tags: '',
        published_date: getFormattedTime(new Date(), "YYYY-MM-DD"),
    });

    useEffect(() => {
        if (editBlog && editBlog._id) {
            let newBlog = {...editBlog};
            if (_.isArray(newBlog.tags)) {
                newBlog.tags = editBlog?.tags?.join(',');
            }
            newBlog.published_date = moment(new Date(editBlog.published_date)).format("YYYY-MM-DD");
            if(selectedSegment === 'update-screen')
            setBlogData(newBlog)
        }
    }, [editBlog, selectedSegment])

    useEffect(() => {
        if (blog_id && !editBlog?._id) {
            dispatch(fetchSingleBlog(blog_id));
        }
    }, [editBlog, blog_id])

    const handleChangeUser = (keyName, keyValue, value2) => {
        let update = {...blogData};
        if (keyName === "publishing_date") {
            update["publishing_date"] = new Date(keyValue?.$d).toISOString();
        } else if (keyName === "preview_image") {
            update["preview_image"] = keyValue;
            update["preview_image_alt"] = value2;
        } else if (keyName === "author_image") {
            update["author_image"] = keyValue;
            update["author_image_alt"] = value2;
        } else {
            update[keyName] = keyValue;
        }
        setBlogData(update);
    };

    const validateBlog = (blogData) => {
        let isValid = true;
        let message = {};
        if (!blogData?.heading?.trim()) {
            isValid = false;
            message["heading"] = "Blog Title cannot be empty";
        }
        if (!blogData?.text?.trim()) {
            isValid = false;
            message["text"] = "Blog Text cannot be empty";
        }
        if( blogData?.text.length<MIN_LENGTH || blogData?.text.length>MAX_LENGTH){
            isValid = false;
            message["text"] = `Characters can't be less than ${MIN_LENGTH} or more than ${MAX_LENGTH}`;
        }
        if (!blogData?.tags?.trim()) {
            isValid = false;
            message["tags"] = "Blog Category cannot be empty";
        }
        if (!blogData?.author_name?.trim()) {
            isValid = false;
            message["author_name"] = "Author Name of the Blog cannot be empty";
        }
        if (!blogData?.preview_image?.trim()) {
             isValid = false;
             message["preview_image"] = "News Item Image cannot be empty";
         }
         if (!blogData?.author_image?.trim()) {
            isValid = false;
            message["author_image"] = "Author Image cannot be empty";
        }
        return {
            isValid,
            message
        }
    }

    const monthPickerLocale = 
       [
            'Jan',
            'Feb',
            'Mrt',
            'Apr',
            'Mei',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Okt',
            'Nov',
            'Dec'
        ];


    const saveData = ()  => {
        let check = validateBlog(blogData);
        if (check.isValid) {
            if (editBlog && editBlog._id) {
                let newBlog = {...blogData};

                const trimmedDetails = {};
                // Trim each attribute and assign it to trimmedDetails object
                for (const key in newBlog) {
                    if (typeof newBlog[key] === "string") {
                        trimmedDetails[key] = newBlog[key].trim();
                    } else {
                        trimmedDetails[key] = newBlog[key];
                    }
                }

                trimmedDetails.tags = trimmedDetails.tags.split(",");
                dispatch(updateBlog(editBlog._id, trimmedDetails, false, t));
            } else {
                let newBlog = {...blogData};
                newBlog.entity_id = activeEntity._id;
                newBlog.organisation_id = activeEntity.organisation_id;

                const trimmedDetails = {};
                // Trim each attribute and assign it to trimmedDetails object
                for (const key in newBlog) {
                    if (typeof newBlog[key] === "string") {
                        trimmedDetails[key] = newBlog[key].trim();
                    } else {
                        trimmedDetails[key] = newBlog[key];
                    }
                }

                trimmedDetails.url = `${_.kebabCase(trimmedDetails.heading)}-${shortid.generate()}`;
                trimmedDetails.tags = trimmedDetails.tags.split(",");

                dispatch(addNewBlog(trimmedDetails, t));
            }
        } else {
            setErrors(check.message);
        }
    }

    let dataList = [
        {label: "Gepubliceerde nieuwsberichten", link: `/mosque/${activeEntity._id}/blogs`},
        {label: `${editBlog.heading}`, link: ""},
    ];

    const onOptionPreviewImage = (details, name) => {
        
        handleChangeUser('preview_image', details, name);
    }

    const onOptionAuthorImage = (details, name) => {
        handleChangeUser('author_image', details, name);
    }

    const disablePastDates = (current) => {
          return current && current < moment().startOf('day');
    };

    return (
        <div className="add_form form_width">
            <Helmet>
                <title>Mosqapp</title>
            </Helmet>
            <div className="mosque-form">
                {/* <h2>Add Member</h2> */}
                <div className="row">
                    <div className="col-lg-6">
                        <label>
                        {t('News Feed Title')}<span style={{color: "#FE1717"}}>*</span>
                        </label>
                        <Input
                            value={blogData?.heading}
                            onChange={(e) => {
                                const value = e.target.value;
                                if(value.length <=120) {handleChangeUser("heading", value);}
                            }}
                            type="text"
                            placeholder={t("Enter News Item Title")}
                            className="input-box"
                        />
                        {errorData.heading ? <ErrorMessage>{t(errorData.heading)}</ErrorMessage> : null}
                    </div>
                    <div className="col-lg-6">
                        <label>
                        {t('Category')}<span style={{color: "#FE1717"}}>*</span>
                        </label>
                        <Input
                            value={blogData.tags}
                            onChange={(e) => {
                                const value = e.target.value;
                                if(value.length <=50) {handleChangeUser("tags", value);}
                            }}
                            type="text"
                            placeholder={t("Enter Category")}
                            className="input-box"
                        />
                        {errorData.tags ? <ErrorMessage>{t(errorData.tags)}</ErrorMessage> : null}
                    </div>

                    <div className="col-lg-6 pt-4">
                        <label>
                        {t('Author Name')}<span style={{color: "#FE1717"}}>*</span>
                        </label>
                        <Input
                            value={blogData.author_name}
                            onChange={(e) => {
                                    const value = e.target.value;
                                    if(value.length <=70) {handleChangeUser("author_name", value);}
                                }}
                            type="text"
                            placeholder={t("Enter Name")}
                            className="input-box"
                        />
                        {errorData.author_name ? <ErrorMessage>{t(errorData.author_name)}</ErrorMessage> : null}
                    </div>
                    <div className="col-lg-6 pt-4">
                        <label>
                        {t('Publication Date')}<span style={{color: "#FE1717"}}>*</span>
                        </label>
                        <DatePickerBox>
                            <DatePicker defaultValue={dayjs()} disabledDate={disablePastDates} value={dayjs(blogData?.published_date, 'YYYY-MM-DD')} onChange={(value) => handleChangeUser("published_date", value)} locale={monthPickerLocale} />
                        </DatePickerBox>
                        {errorData.published_date ? <ErrorMessage>{t(errorData.published_date)}</ErrorMessage> : null}
                    </div>
                    <div className="col-lg-12 pt-3">
                        <label>
                        {t('News Item Details')} <span style={{color: "#FE1717"}}>*</span>
                        </label>
                        <textarea
                            value={blogData.text}
                            onChange={(e) =>
                                handleChangeUser("text", e.target.value)
                            }
                            //   placeholder="Enter Membership"
                            className="input-boxx"
                            style={{ padding: "10px" }}
                            minLength={MIN_LENGTH}
                            maxLength={MAX_LENGTH}
                        />
                       <div style={{display:"flex", textAlign:"center", flexDirection:'row-reverse', justifyContent:'space-between'}} >
                       <p style={{textAlign:'right', color:'#dc3545'}}>{t("Character's typed")}: {blogData?.text.length}</p>
                       {errorData.text ? <ErrorMessage>{t(errorData.text)}</ErrorMessage> : null}
                       </div>
                    </div>
                    <div className="col-lg-6 mt-4">
                        <label>
                        {t('News Item Image')}<span style={{color: "#FE1717"}}>*</span>
                        </label>
                        <UploadFile
                            id="preview"
                            onOptionClick={(data, name) => onOptionPreviewImage(data, name)}
                            fileName={blogData?.preview_image_alt}
                            bg="#fff"
                            height="66px"
                        />
                        {errorData.preview_image ? <ErrorMessage>{t(errorData.preview_image)}</ErrorMessage> : null}
                    </div>
                    <div className="col-lg-6 mt-4" style={{pointerEvents:(blogData?.preview_image)?'':'none'}}>
                        <label>
                        {t('Author Image')}<span style={{color: "#FE1717"}}>*</span>
                        </label>
                        <UploadFile
                            id="author"
                            onOptionClick={(data, name) => onOptionAuthorImage(data, name)}
                            fileName={blogData?.author_image_alt}
                            bg="#fff"
                            isDisabled={!blogData?.preview_image}
                            height="66px"
                        />
                        {errorData.author_image ? <ErrorMessage>{t(errorData.author_image)}</ErrorMessage> : null}
                    </div>
                </div>
                <Box display="flex" justifyContent="center">
                    <Box mr="30px">
                        <Button
                            onClick={() => navigate(-1)}
                            text={t("Cancel")}
                            borderRadius="66px"
                            textColor="#fff"
                            width="160px"
                            mt="5"
                            mx="auto"
                            height="60px"
                        />
                    </Box>
                    <Box>
                        <Button
                            type={"primary"}
                            onClick={() => saveData()}
                            text={t('Publiceer nieuwsbericht')}
                            borderRadius="66px"
                            textColor="#fff"
                            width="160px"
                            mt="5"
                            mx="auto"
                            height="60px"
                        />
                    </Box>
                </Box>
                <br/>
            </div>
        </div>
    );
}

export default PublishBlog;
